import { Box, Stack, CircularProgress } from '@mui/material';

type LoadingSpinnerProps = {
  size?: number;
};

export default function LoadingSpinner({ size = 80 }: LoadingSpinnerProps) {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
      }}
    >
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={size} />
      </Stack>
    </Box>
  );
}
